import {
  Component,
  EventEmitter,
  Input,
  OnDestroy,
  OnChanges,
  Output,
  SimpleChanges,
  ChangeDetectionStrategy
} from '@angular/core';

import { SharedModule } from '../shared.module';
import { TranslatePipe } from '@ngx-translate/core';
import { VwDatePipe } from '../../pipes/vw-date.pipe';

/**
 * Célébration affichée au moment où le premium s'active.
 *
 * Pourquoi ce moment mérite un écran à lui : l'achat se conclut HORS de l'app,
 * dans le navigateur. L'utilisateur revient sans savoir si son paiement a
 * abouti. Un simple changement de libellé quelque part ne répond pas à cette
 * question — il faut lui dire, franchement, que c'est fait.
 *
 * Elle se ferme seule : personne ne veut d'un obstacle entre soi et ce qu'on
 * vient de payer. Un appui n'importe où la ferme aussi.
 */
@Component({
  selector: 'vw-premium-celebration',
  standalone: true,
  imports: [TranslatePipe, VwDatePipe, SharedModule],
  templateUrl: './premium-celebration.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrl: './premium-celebration.component.scss',
})
export class PremiumCelebrationComponent implements OnChanges, OnDestroy {
  @Input() isOpen = false;
  /** Essai gratuit ou abonnement payé : le message diffère. */
  @Input() trial = false;
  /** Fin de l'essai (ISO), affichée sous le titre : « Jusqu'au 12/11/2026, sans engagement. » */
  @Input() trialEnd?: string | null;

  @Output() closed = new EventEmitter<void>();

  /** Confettis générés une fois, avec des trajectoires figées. */
  readonly confetti = Array.from({ length: 18 }, (_, i) => ({
    left: (i * 5.4 + ((i * 37) % 11)) % 100,
    delay: ((i * 13) % 9) / 10,
    duration: 2.4 + ((i * 7) % 12) / 10,
    // Les couleurs des confettis viennent des jetons (accent et filet Premium, verts de l'app).
    color: ['var(--vw-premium-accent)', 'var(--vw-primary)', 'var(--vw-premium-line)', 'var(--vw-surface-tint)'][i % 4],
    tilt: ((i * 29) % 60) - 30,
  }));

  private timer?: ReturnType<typeof setTimeout>;

  ngOnChanges(changes: SimpleChanges): void {
    if (!changes['isOpen']) return;
    clearTimeout(this.timer);
    if (this.isOpen) {
      this.timer = setTimeout(() => this.close(), 5200);
    }
  }

  ngOnDestroy(): void {
    clearTimeout(this.timer);
  }

  close(): void {
    if (!this.isOpen) return;
    clearTimeout(this.timer);
    this.closed.emit();
  }
}
